function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { Chip } from '@mui/material';
import { LinkOnComponent } from 'app/components/links/link';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import ChipImage from 'app/components/chip/ChipImage';
import ClubShortcutSyndicateTeamDialog from 'app/components/team/teamShortcuts/clubShortcutSyndicateTeamDialog';
const StyledChipImage = styled(ChipImage).withConfig({
  componentId: "sc-19d7uik-0"
})(["img{padding:2px;}"]);
const ClubShortcut = _ref => {
  let {
    teams,
    club
  } = _ref;
  const [openDialog, setOpenDialog] = useState(false);
  const isSyndicateTeam = useMemo(() => {
    if (!teams) {
      return false;
    }
    return teams.length > 1;
  }, [teams]);
  if (!(club !== null && club !== void 0 && club.slug)) {
    return null;
  }
  const clubLinkImage = /*#__PURE__*/React.createElement(StyledChipImage, {
    entity: 'emblem',
    src: club.image,
    ratio: '1:1',
    fit: true
  });
  const toggleDialog = () => {
    setOpenDialog(!openDialog);
  };
  const chipProps = isSyndicateTeam ? {
    onClick: toggleDialog
  } : {
    component: LinkOnComponent,
    to: "/club/".concat(club.slug)
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chip, _extends({
    style: {
      display: 'flex'
    },
    avatar: clubLinkImage,
    label: 'Zum Verein',
    variant: "outlined",
    clickable: true
  }, chipProps, {
    "data-sentry-element": "Chip",
    "data-sentry-source-file": "clubShortcut.tsx"
  })), isSyndicateTeam && /*#__PURE__*/React.createElement(ClubShortcutSyndicateTeamDialog, {
    onClose: toggleDialog,
    open: openDialog,
    teams: teams
  }));
};
export default ClubShortcut;